import { render } from "./Contact.vue?vue&type=template&id=34924388&scoped=true&bindings={\"isLoading\":\"data\",\"error\":\"data\",\"sendBooking\":\"data\",\"text\":\"options\",\"images\":\"options\",\"loadCategories\":\"options\",\"handleError\":\"options\",\"showSentDialog\":\"options\",\"handleSendBooking\":\"options\"}"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=34924388&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34924388"

export default script